import { render, staticRenderFns } from "./ProductWholesaleForm.vue?vue&type=template&id=c21f071e&"
import script from "./ProductWholesaleForm.vue?vue&type=script&lang=js&"
export * from "./ProductWholesaleForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductWholesaleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports